var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader",class:{inline: _vm.inline}},[_c('span',{staticClass:"fa fa-spin fa-circle-o-notch"})])}
var staticRenderFns = []

export { render, staticRenderFns }